export default __webpack_public_path__ + "static/media/Logo.445b5946.webp";